import * as React from 'react'
import { ClassName } from '@type/component-data-types'

type Props = {
  question: string
  children: React.ReactNode
  className?: ClassName
}

const InterviewQa = (props: Props): React.JSX.Element => {
  const rootClassName = props.className
    ? `interviewQa ${props.className}`
    : 'interviewQa'

  return (
    <div className={rootClassName}>
      <p className="interviewQa__question">──{props.question}</p>
      <div className="interviewQa__answer">{props.children}</div>
    </div>
  )
}

export default InterviewQa
